import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import RouterContainer from "./containers/RouterContainer";
import { TRPCProvider } from "./trpc/TRPCProvider";
import { StytchB2BProvider } from "@stytch/react/b2b";
import { StytchB2BUIClient } from "@stytch/vanilla-js/b2b";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";

const stytch = new StytchB2BUIClient(import.meta.env.VITE_STYTCH_PUBLIC_TOKEN_INTERNAL);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary surface="root">
      <StytchB2BProvider stytch={stytch}>
        <TRPCProvider>
          <RouterContainer />
          <Toaster />
        </TRPCProvider>
      </StytchB2BProvider>
    </ErrorBoundary>
  </StrictMode>
);
